import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Header, Grid, Segment } from 'semantic-ui-react';
import api from '../../../api';
import QualitativeDetails from './QualitativeDetails';
import EstadisticasFormula from './EstadisticasFormula';

const headerStyle = { marginTop: '5px', marginBottom: '5px' };

class DetailsFormula extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formula: {
        Discursivas: [],
        Variantes: [],
        Ejemplos: []
      }
    };
  }

  componentDidMount = () => {
    const { match } = this.props;
    api.formulas
      .getFormulaById(match.params.formulaId)
      .then(formula => this.setState({ formula }));
  };

  render() {
    const { formula } = this.state;
    return (
      <div>
        <Segment>
          <Header as="h2" icon textAlign="center" style={headerStyle}>
            <Header.Content>
              Fórmula: <em>{formula.texto}</em>
            </Header.Content>
          </Header>
        </Segment>
        <Grid columns="equal">
          <Grid.Column>
            <QualitativeDetails formula={formula} />
          </Grid.Column>
          <Grid.Column>
            <Header as="h3" block attached="top" color="blue">
              Datos cuantitativos
            </Header>
            <Segment attached>
              <EstadisticasFormula 
                texto={formula.texto} 
                tipoCorpus={formula.tipoCorpus}
              />
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

DetailsFormula.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      formulaId: PropTypes.string.isRequired
    })
  }).isRequired
};

export default withRouter(DetailsFormula);
